import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = { transform: "translate(0 18)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  dur: "2",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  keyTimes: "0;0.5;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "-3 0;3 0;-3 0"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "a",
    d: "M0 0v100h100V0H0zm62.9 44.4c-1.7 3.4-5.3 5.8-9.4 5.8H17c-5.8 0-10.5-4.7-10.5-10.5 0-5.2 3.8-9.6 8.9-10.4-.1-.6-.2-1.3-.2-2 0-5.5 4.4-9.9 9.9-9.9 1 0 2 .2 3 .5 2.5-4.7 7.4-7.9 13.1-7.9 6.9 0 12.8 4.8 14.4 11.2.3 1.2.4 2.4.4 3.6 0 1.6-.2 3.1-.7 4.5 5 .8 8.7 5.2 8.7 10.3 0 1.7-.4 3.4-1.1 4.8z"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      calcMode: "spline",
      dur: "2",
      keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
      keyTimes: "0;0.5;1",
      repeatCount: "indefinite",
      type: "translate",
      values: "-3 0;3 0;-3 0"
    })
  ])
], -1)
const _hoisted_7 = { "clip-path": "url(ldio-ms2xz5ap1p-cp)" }
const _hoisted_8 = ["fill"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  dur: "1.32",
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  keyTimes: "0;0.5;1",
  repeatCount: "indefinite",
  type: "translate",
  values: "-3 0;3 0;-3 0"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

import { toRefs } from 'vue'

    interface Props {
        color1?: string
        color2?: string
        width?: string
        height?: string
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
    color1: { default: '#7dd3fc' },
    color2: { default: '#bae6fd' },
    width: { default: '50vw' },
    height: { default: '50vh' }
  },
  setup(__props: any) {

const props = __props as { color1: string, color2: string, width: string, height: string }

    

    const { color1, color2, width, height } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _unref(width),
    height: _unref(height),
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        fill: _unref(color1),
        d: "M53.2 30.3c.4-1.3.6-2.7.6-4.2 0-1.2-.1-2.3-.4-3.4-1.5-6-7-10.5-13.5-10.5-5.3 0-9.9 3-12.3 7.4-.9-.3-1.8-.4-2.8-.4-5.1 0-9.3 4.1-9.3 9.3 0 .6.1 1.3.2 1.9-4.7.7-8.3 4.8-8.3 9.7 0 5.4 4.4 9.8 9.8 9.8h34.2c3.8 0 7.1-2.2 8.8-5.4.7-1.3 1.1-2.9 1.1-4.5.1-4.8-3.5-8.9-8.1-9.7z"
      }, _hoisted_5, 8, _hoisted_3),
      _hoisted_6,
      _createElementVNode("g", _hoisted_7, [
        _createElementVNode("path", {
          fill: _unref(color2),
          d: "M84.9 28.9c.4-1.1.6-2.3.6-3.5 0-1-.1-1.9-.4-2.8-1.3-5-6.1-8.7-11.8-8.7-4.6 0-8.7 2.5-10.7 6.1-.8-.2-1.6-.4-2.4-.4-4.5 0-8.1 3.4-8.1 7.6 0 .5.1 1 .2 1.5-4.1.6-7.2 4-7.2 8 0 4.5 3.8 8.1 8.6 8.1h29.8c3.3 0 6.2-1.8 7.7-4.4.6-1.1.9-2.3.9-3.7-.1-3.8-3.2-7.1-7.2-7.8z"
        }, _hoisted_10, 8, _hoisted_8)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})